// Legacy SoftR/Airtable parity (Angel, Stef mtg 8/20): the reviewer's PubMed link defaults to a
// name search — 'https://pubmed.ncbi.nlm.nih.gov/?term=' & ENCODE_URL_COMPONENT(first & " " & last)
// — prefilled but fully editable in both the student and AE flows.
export const pubmedSearchUrl = (firstName: string | null, lastName: string | null): string =>
  `https://pubmed.ncbi.nlm.nih.gov/?term=${encodeURIComponent(`${firstName ?? ""} ${lastName ?? ""}`.trim())}`;
